import { render, staticRenderFns } from "./IndicadorConexion.vue?vue&type=template&id=5e23093d"
import script from "./IndicadorConexion.vue?vue&type=script&lang=js"
export * from "./IndicadorConexion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports